<app-base-complex-statistics
[title]="title"
[getDetailComplexStatisticsApiMethodName]="getDetailComplexStatisticsApiMethodName"
[getComplexStatisticsApiMethodName]="getComplexStatisticsApiMethodName"
[isShowOrganizationDropDown]="true"
[isShowUserDropDown]="true"
[lineComplexChartId]="lineComplexChartId"
[barComplexChartId]="barComplexChartId"
[userType]="userType"
[isAdminStats]="true"
>
</app-base-complex-statistics>
